import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './WhoWeAreSection.css';

const whoWeAreText = `The Sustainable Solutions Initiative (SSI) is a non-governmental organization committed to creating innovative responses to social, environmental, and economic challenges.
Beyond designing and managing European Union projects, we work through strong partnerships to advance sustainability, inclusivity, and positive change across areas such as education, environment, digital transformation, and youth empowerment.`;

const visualUrl = "https://res.cloudinary.com/dpuo4ow5h/image/upload/v1758389738/Gemini_Generated_Image_7uoqjv7uoqjv7uoq_fmt3de.png";

const WhoWeAreSection = () => (
  <section className="who-modern-section">
    <div className="who-modern-section-bg" />
    <div className="who-modern-container">
      {/* Görsel animasyonu */}
      <motion.div
        className="who-modern-visual"
        initial={{ opacity: 0, scale: 0.92, x: 60 }}
        whileInView={{ opacity: 1, scale: 1, x: 0 }}
        transition={{ duration: 1.1, ease: [0.4, 0, 0.2, 1] }}
        viewport={{ once: true, amount: 0.5 }}
      >
        <img src={visualUrl} alt="Who We Are Visual" className="who-modern-img" />
        <motion.div
          className="who-modern-img-glow"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 0.7 }}
          transition={{ duration: 1.2, delay: 0.5 }}
          viewport={{ once: true }}
        />
      </motion.div>
      <div className="who-modern-content">
        {/* Başlık animasyonu */}
        <motion.h2
          className="who-modern-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true, amount: 0.5 }}
        >
          Who We Are?
        </motion.h2>
        {/* Açıklama animasyonu */}
        <motion.p
          className="who-modern-desc"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          viewport={{ once: true, amount: 0.5 }}
        >
          {whoWeAreText}
        </motion.p>
        {/* Buton animasyonu */}
        <motion.div
          className="who-modern-btn-area"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          viewport={{ once: true, amount: 0.5 }}
        >
          <Link to="/about" className="who-modern-btn">
            More About Us
          </Link>
        </motion.div>
      </div>
    </div>
  </section>
);

export default WhoWeAreSection;